import React from 'react';
import UnitTopNavigation from './unitTopNavigation/UnitTopNavigation';

const CreateUnit = () => (
  <UnitTopNavigation />
);

export default CreateUnit;
